import { useMutation, useQueryClient } from '@tanstack/react-query';
import { auditLogApi } from '../api/auditLogApi';
import type { PurgeResponse } from '../types/auditLog';

/**
 * 감사 로그 전체 삭제 mutation hook.
 * DELETE /api/eraf/audit-logs/all (AUDIT_DELETE_ALL)
 */
export function usePurgeAuditLogs() {
  const queryClient = useQueryClient();

  return useMutation<PurgeResponse, { code?: string; message?: string }>({
    mutationFn: () => auditLogApi.purgeAll(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['audit-log'] });
    },
  });
}
